'use client';

import React from 'react';
import setAlertValue from '@/components/Alert';
import { AuthContext } from '@/context/create-context';
import { removeCookie } from '@/utils/storage';
import { UserPropsType, UserDataType } from '@/types/auth';
import { logout as userLogout, getCurrentUser } from '@/api/auth';

export const AuthProvider = (props: UserPropsType) => {
  const { user: defaultUser = null, isMiniProgram = false } = props;

  const [user, setUser] = React.useState<UserDataType | null>(
    defaultUser || null,
  );

  React.useEffect(() => {
    // if user data isn't passed to props, send request to fetch user data
    if (!user && !isMiniProgram) {
      getCurrentUser()
        .then((res) => {
          if (res.status === 200) {
            setUser(res.data);
          }
        })
        .catch(() => {
          setAlertValue({ msg: '登录失败，请重试' });
          removeCookie('user_id');
        });
    }
  }, []);

  const logout = async () => {
    try {
      await userLogout();
      setUser(null);
      sessionStorage.clear();
      localStorage.clear();
      removeCookie('user_id');
      return true;
    } catch (error) {
      setAlertValue?.({ msg: '退出登录失败，请重试' });
      throw error;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        logout,
        isLogin: !!user?.is_authenticated,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
